var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"upload",staticClass:"input_upload_file",class:_vm.className,attrs:{"type":"file","accept":_vm.formatValue},on:{"change":_vm.tellFun}}),_c('div',{staticClass:"upload-div",on:{"click":_vm.uploadClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }